import Link from "next/link";
import styles from "./BreadCrumbs.module.css";
interface Props {
  countryName: string;
  pageName: string;
  items?: Array<{
    name: string;
    pathname: string;
  }>;
}

export default function Breadcrumbs({ pageName, items, countryName }: Props) {
  return (
    <>
      <nav aria-label="breadcrumbs" className={styles.BreadCrumb}>
        <ol>
          <li>
            <Link href={`/tours-${countryName.toLocaleLowerCase()}`}>
              {countryName} Tours
            </Link>
          </li>
          {items
            ? items.map((item, index) => {
                return (
                  <li key={index}>
                    {item.pathname !== undefined ? (
                      <Link href={item.pathname}>{item.name}</Link>
                    ) : (
                      item.name
                    )}
                  </li>
                );
              })
            : null}

          <li>{pageName}</li>
        </ol>
      </nav>
    </>
  );
}
